module.exports = __webpack_public_path__ + "media/assets/icons/ic-radio-button-selected-9d9550d5a19f3bbc647d42bf3009ab26.svg";